/* Generated file. Do not modify. Please check more details in build/generate.ts */
import * as React from "react";
import type { IconProps } from "../IconTypes";
import { IconWrapper } from "../IconWrapper";
export function PlayIcon(props: IconProps) {
    return (<IconWrapper {...props}>
            {<path d="M36 20c0 8.875-7.187 16-16 16-8.875 0-16-7.125-16-16 0-8.812 7.125-16 16-16 8.813 0 16 7.188 16 16m-20.25-6.75c-.5.25-.75.75-.75 1.25v11c0 .563.25 1.063.75 1.313.438.312 1.063.25 1.5 0l9-5.5c.438-.313.75-.75.75-1.313 0-.5-.312-1-.75-1.25l-9-5.5c-.437-.312-1.062-.312-1.5-.062z"/>}
        </IconWrapper>);
}
